/** Widget / çağrı kaydı için randevu normalizasyonu */
export function normalizeWidgetAppointment(raw) {
  if (!raw) return null;
  const a = raw.data || raw.appointment || raw;
  if (!a || (!a.department && !a.id && !a.plate)) return null;
  const confirmed = a.confirmed === true || a.status === 'confirmed';
  return { ...a, confirmed };
}

export function buildWidgetCallSummary(appt) {
  const a = normalizeWidgetAppointment(appt);
  if (!a) return null;
  const name =
    a.customerName || `${a.firstName || ''} ${a.lastName || ''}`.trim() || null;
  const parts = [
    `Randevu ${a.date || '?'} ${a.time || '?'}`,
    a.department && a.department,
    name && name,
    a.customerPhone && `tel ${a.customerPhone}`,
    a.visitType && a.visitType,
    a.chiefComplaint && `şikayet: ${a.chiefComplaint}`,
  ].filter(Boolean);
  return `Web paneli — ${parts.join(' · ')}`;
}

export function widgetCallStatus(appt) {
  const a = normalizeWidgetAppointment(appt);
  if (!a) return 'Success';
  return a.confirmed ? 'Appointment Created' : 'Appointment Requested';
}

export const WIDGET_APPT_STORAGE_KEY = 'aktif-widget-appointment';
